import { Dialog, DialogContainer, DialogHeader } from './Dialog.styles'
import { Button } from '@common/components/Button'
import { useTheme } from '@emotion/react'
import styled from '@emotion/styled'
import { IonIcon } from '@ionic/react'
import { checkboxSharp, lockClosedSharp, searchSharp } from 'ionicons/icons'
import { useRouter } from 'next/navigation'

const BulletContainer = styled.div`
  display: flex;
  flex-direction: row;
  min-height: 2.2rem;

  .icon {
    display: block;
    color: ${({ theme }) => theme.primary};
    padding-right: 1rem;
    width: 1.2rem;
    height: 1.2rem;
  }

  color: ${({ theme }) => theme.onBackgroundSemiLight};
`

export const PageCreatedDialog = ({ name }: { name: string }) => {
  const theme = useTheme()
  const router = useRouter()

  return (
    <DialogContainer
      onSubmit={(e) => {
        e.preventDefault()
      }}
    >
      <Dialog>
        <DialogHeader style={{ marginBottom: '2.5rem' }}>
          Välkommen till Booet,
          <br /> <span style={{ color: theme.primaryLight }}>{name}</span>
        </DialogHeader>
        <BulletContainer>
          <div>
            <IonIcon className="icon" icon={searchSharp} />
          </div>
          Utforska hemsidan och dess funktionalitet i lugn och ro
        </BulletContainer>
        <BulletContainer style={{ marginTop: '1rem' }}>
          <div>
            <IonIcon className="icon" icon={lockClosedSharp} />
          </div>
          Hemsidan är privat tills registreringen är färdigställd
        </BulletContainer>
        <BulletContainer style={{ marginTop: '1rem' }}>
          <div>
            <IonIcon className="icon" icon={checkboxSharp} />
          </div>
          Gör genomgången i kontrollpanelen för att öppna upp för alla
        </BulletContainer>
        <Button
          onClick={() => {
            router.replace(
              process.env.NODE_ENV === "production" ? 'https://admin.booet.se/' : 'http://admin.localhost.test:5173',
            )
          }}
          style={{ marginTop: '2rem' }}
        >
          Kom igång
        </Button>
      </Dialog>
    </DialogContainer>
  )
}
